export default {

    /**
     * Get list
     * @param state
     * @returns {default.campaigns|{}}
     */
    getIntervals: state => (node_id) => {

        // Return  list
        return Object.values(state.intervals).filter((ut) => ( ut.node_id === node_id && !ut.deleted_at));
    },

    /**
     * Get by id
     * @param state
     * @returns {default.campaigns|{}}
     */
    getIntervalByID: state => (id) => {
        // Return  list
        return state.intervals[id];
    },

    /**
     * Get list
     * @param state
     * @returns {default.campaigns|{}}
     */
    getDepartments: state => (node_id) => {

        // Return  list
        return Object.values(state.departments).filter((ut) => ( ut.node_id === node_id && !ut.deleted_at));
    },

    /**
     * Get by id
     * @param state
     * @returns {default.campaigns|{}}
     */
    getDepartmentByID: state => (id) => {
        // Return  list
        return state.departments[id];
    },

    /**
     * Get list
     * @param state
     * @returns {default.campaigns|{}}
     */
    getGoals: state => (node_id) => {

        // Return  list
        return Object.values(state.goals).filter((ut) => ( ut.node_id === node_id && !ut.deleted_at));
    },

    /**
     * Get by id
     * @param state
     * @returns {default.campaigns|{}}
     */
    getGoalByID: state => (id) => {
        // Return  list
        return state.goals[id];
    },


    /**
     * Get list
     * @param state
     * @returns {default.campaigns|{}}
     */
    getBudgets: state => (node_id) => {

        // Return  list
        return Object.values(state.budgets).filter((ut) => ( ut.node_id === node_id && !ut.deleted_at));
    },

    /**
     * Get by id
     * @param state
     * @returns {default.campaigns|{}}
     */
    getBudgetByID: state => (id) => {
        // Return  list
        return state.budgets[id];
    },

    /**
     * Get list
     * @param state
     * @returns {default.campaigns|{}}
     */
    getIncomes: state => (node_id) => {

        // Return  list
        return Object.values(state.incomes).filter((ut) => ( ut.node_id === node_id && !ut.deleted_at));
    },

    /**
     * Get by id
     * @param state
     * @returns {default.campaigns|{}}
     */
    getIncomeByID: state => (id) => {
        // Return  list
        return state.incomes[id];
    }


}
